<template lang="pug">
  #entity-property-values.right-panel.md-elevation-1.md-scrollbar.md-theme-default
    .md-layout-row.header
      .md-flex
        md-button.md-icon-button.md-dense.close.small(v-bind:to="{ name: 'Entity', params: { code: $route.params.code, entity_code: $route.params.entity_code}, query: $route.query}"): md-icon close

        div(v-if="values.length && property")
          div(v-for="(value, key) in values" v-bind:key="key")
            div.value-header
              span Значение {{(key+1)}}
              md-button.md-dense.md-icon-button(v-if="key > 0" v-on:click="removePropertyValue(key)") #[md-icon delete]
            md-field
              label Символьный код
              md-input( v-model="value['code']")
            md-field
              label Значение
              md-input( v-model="value['name']")
            md-field
              label Сортировка
              md-input( v-model="value['sort']" type="number")
            br
        md-button.md-dense(v-on:click="values.push({code: '', name: '', sort: 100})") Добавить значение #[md-icon add]
        br
        md-button.md-primary(v-on:click="pushValues()") Сохранить
        md-button.md-accent(v-bind:to="{ name: 'Entity', params: { code: $route.params.code, entity_code: $route.params.entity_code}, query: $route.query}") Отмена
</template>

<script>
  import ModuleMenu from './menu.vue';
  import EditArea from '@/components/EditArea'

  export default {
    data() {
      return {
        property: {},
      }
    },
    components: {
      ModuleMenu,
      EditArea
    },
    computed: {
      values() {
        return this.$store.state.module.entity_property_values;
      },
      properties() {
        return this.$store.state.module.entity_properties;
      },
    },
    watch: {
      'property'(newVal, oldVal) {
        if(!Object.keys(oldVal).length) {
          this.getPropertyValues();
        }
      },
      'properties'(newVal) {
        this.getProperty();
      },
      '$route.params.entity_prop_code'() {
        this.$store.commit('openRightPanel');
      },
    },
    created() {
      this.$store.commit('openRightPanel');
      this.$store.dispatch('module/getModuleEntities');
      this.$store.dispatch('module/getModuleEntitiesProperties');
      this.getProperty();
      this.getPropertyValues();
    },
    methods: {
      pushValues() {
        let data = {
          'property_id': this.property.id,
          'values': this.values
        };
        this.$store.dispatch('module/updateModuleEntitiesPropertyValues', data).then(response => {
          this.getPropertyValues();
          this.$router.push({
            name: 'Entity',
            params: {entity_code: this.$route.params.entity_code}
          });
        });
      },
      getPropertyValues() {
        if(Object.keys(this.property).length) {
          this.$store.dispatch('module/getModuleEntitiesPropertyValues', this.property.id);
        }
      },
      removePropertyValue(index) {
        let value = this.values[index];
        if (value && Object.keys(this.property).length) {
          if (value.id) {
            this.$store.dispatch('module/removeModuleEntitiesPropertyValues', {property_id: this.property.id, id: value.id}).then(response => {
              this.values.splice(index, 1);
              this.getPropertyValues();
            });
          } else {
            this.values.splice(index, 1);
          }
        }
      },
      getProperty(){
        if(Object.keys(this.properties).length) {
          this.property = this.properties.find(x => x.code === this.$route.params.entity_prop_code);
        }
      }
    }
  }
</script>
<style scoped lang="sass">
  #entity-property-values
    .value-header
      display: flex
      align-items: center
      justify-content: flex-start
</style>



// WEBPACK FOOTER //
// EntityPropertyValues.vue?34ffeb6b